import classNames from 'classnames';

const TableBody = props => {
  return (
    <tbody
      className={classNames('c-table__body', props.extraClassNames)}
      style={props.style}
    >
      {props.children}
    </tbody>
  );
};

export default TableBody;
